import angularModule from 'Authentication/angularModule/scripts/authentication_module';
import template from 'Authentication/angularModule/views/forgot_password.html';
import cacheAngularTemplate from 'cacheAngularTemplate';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('forgotPassword', [
    '$injector',

    function factory($injector) {
        const AuthClient = $injector.get('AuthClient');
        const NavigationHelperMixin = $injector.get('Navigation.NavigationHelperMixin');
        const TranslationHelper = $injector.get('TranslationHelper');
        return {
            restrict: 'E',
            templateUrl,
            scope: {
                urlPrefix: '<',
            },
            link(scope) {
                const $rootScope = $injector.get('$rootScope');
                const safeApply = $injector.get('safeApply');
                const translationHelper = new TranslationHelper('authentication.forgot_password');

                NavigationHelperMixin.onLink(scope);

                scope.preventSubmit = false;
                scope.form = {};
                scope.form_errors = {};
                scope.submitted = false;

                scope.requestPasswordReset = () => {
                    scope.preventSubmit = true;

                    AuthClient.resetPassword(scope.form)
                        .then(
                            () => {
                                scope.preventSubmit = false;
                                scope.submitted = true;
                            },
                            () => {
                                scope.preventSubmit = false;
                                scope.submitted = false;
                                scope.form_errors.email = translationHelper.get('unable_to_process_your_request');
                            },
                        )
                        .finally(() => {
                            safeApply($rootScope);
                        });
                };
            },
        };
    },
]);
